import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { TileFilter } from '../shared/TileFilter'
import { useGetOrgChart } from './useGetOrgChart'
import { OrgChartContent, OrgChartContentLoading } from './OrgChartContent'

export const OrgChartComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data } = useGetOrgChart(id, tileFilterSelections)

  return (
    <OrgChartContent
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function OrgChartComponentLoading() {
  return <OrgChartContentLoading />
}
